let initMember = {
	expires: 0,
	fetching: false,
	updating: false,
	data: {
		member_no: 0,
		active: false,
		early_enrol: 0,
		membership_expiry_date: "",
		join_year: 0,
		join_date: "",
		date_activated: "",
		date_inactivated: "",
		current_member: false,
		enrolled_subscription: "",
		enrolled_subs_expiry: "",
		enrolled_subs_name: "",
		no_enrol_member_type: false,
		distance_member_type: false,
		gender: "",
		surname: "",
		first_name: "",
		preferred_name: "",
		address1: "",
		street: "",
		suburb: "",
		postcode: "",
		state: "",
		country: "",
		phone_home: "",
		phone_business: "",
		mobile: "",
		email: "",
		employer: "",
		fax: "",
		member_type: "",
		occupation: "",
		registration: "",
		registration_date: "",
		classification: "",
		classifier1: "",
		classifier2: "",
		classifier3: "",
		spare_field: "",
		checkbox1: false,
		checkbox2: false,
		checkbox3: false,
		checkbox4: false,
		birth_year: 0,
		emergency_contact: "",
		emergency_number: "",
		emergency_relationship: "",
		received_date: "",
		number1: 0,
		number2: 0,
		tickets: 0,
		notes: "",
		vaccinated: false 
	}
};

const member = (state = initMember, action) => {
	const exp = Math.floor(Date.now() / 1000) + 3600; // current time + 1 hr 
	
	switch (action.type) {
		case 'USER_FAILURE':
		case 'MEMBER_FAILURE':
		case 'LOGOUT_SUCCESS':
			return initMember;
		case 'MEMBER_SUCCESS':
			return {...state, data: action.response, expires: exp, fetching: false }
		case 'UPDATE_MEMBER_SUCCESS':
			return {...state, data: action.response, expires: exp, updating: false }
		case 'MEMBER_REQUEST':
			return {...state, fetching: true }
		case 'UPDATE_MEMBER_REQUEST':
			return {...state, updating: true }
		case 'UPDATE_MEMBER_FAILURE':
			return {...state, updating: false}
		default:
			return state;
	}
}

export default member